import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return <DefaultFooter style={{ backgroundColor: 'transparent' }} copyright="shoppykey" links={[]} />;
};
export default Footer;
